import { jsonProperty, Serializable } from 'ts-serializable';

class ComponentAbasModel extends Serializable {
    @jsonProperty(Number)
    id: number = -1;

    @jsonProperty(String)
    title: string = '';

    @jsonProperty(String)
    description: string = '';

}

export default ComponentAbasModel;
